<template>
    <h3 class="section-sub-title h4">{{ text }}</h3>
</template>

<script>
export default {
    props: ["text"]
}
</script>

<style lang="scss" scoped>
h3 {
    text-align: center;
    margin: 30px 0;
}
</style>
